import { render } from "./App.vue?vue&type=template&id=6838b128"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6838b128&lang=css"
import "./App.vue?vue&type=style&index=1&id=6838b128&lang=scss"

import exportComponent from "/root/archives/ecopara/samokat-ecokon/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__